/**
 * Button 의 위계(variant) → buttonBase 의 padding variant 매핑.
 *
 * buttonBase 는 padding × size 만 책임지고 색/배경/border 는 color recipe(button)가 처리한다.
 * - filled/outlined/subtle 위계는 padding=default (배경/보더가 있어 horizontal padding 이 넓음)
 * - text 위계는 padding=narrow (배경/보더가 없어 horizontal padding 이 좁음)
 */

export type ButtonHierarchy = 'impact' | 'primary' | 'secondary' | 'tertiary' | 'quaternary';
export type ButtonBasePadding = 'default' | 'narrow';

export const VARIANT_TO_PADDING: Record<ButtonHierarchy, ButtonBasePadding> = {
  impact: 'default',
  primary: 'default',
  secondary: 'default',
  tertiary: 'default',
  quaternary: 'narrow',
};
